import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgUs = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "M12 0 0 12c0 1.386.235 2.718.668 3.956l.602.746-.204.25a12.05 12.05 0 0 0 4.28 5.035l6.509.729 6.825-.746c1.89-1.269 3.4-3.06 4.32-5.169l-.125-.184.42-.554A12 12 0 0 0 24 12l-.994-1.598.696-1.073C22.487 3.987 17.709 0 12 0"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "M11.963 24h.074a11.95 11.95 0 0 0 7.437-2.611H4.526a11.95 11.95 0 0 0 7.438 2.61ZM1.762 18.262h20.476a12 12 0 0 0 1.35-3.13H.412c.3 1.116.759 2.168 1.349 3.13Zm21.825-9.393c.27.998.413 2.048.413 3.13H12l-.895-3.13zm-1.349-3.132H11.105V2.611h8.369a12 12 0 0 1 2.764 3.126"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M12 0C5.373 0 0 5.373 0 12h12z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "m.092 10.507.611-.448 1.017.741-.389-1.19 1.017-.746H1.092L.75 7.814a12 12 0 0 0-.658 2.693m1.051-3.625.572.416-.306-.945q-.14.26-.266.53Zm.555-1.04.65-.48h-.347a12 12 0 0 0-.303.48m2.629-3.069-.338 1.038 1.017-.74 1.017.74-.389-1.19 1.022-.746h-1.1q-.644.412-1.23.898Zm4.598-.893.389-1.2.389 1.195h1.256l-1.017.75.384 1.186-1.012-.736-1.017.74.389-1.195-1.017-.74zM4.617 5.377l.39-1.196.393 1.19h1.256l-1.017.75.384 1.187-1.012-.736-1.017.74.389-1.195-1.018-.74zm4.303 0 .39-1.196.393 1.19h1.252l-1.018.75.385 1.187-1.013-.736-1.017.74.39-1.195-1.018-.74zM4.617 8.864l.39-1.195.388 1.2h1.256l-1.017.745.39 1.19-1.018-.74-1.017.74.389-1.195-1.017-.745zm4.303 0 .39-1.195.393 1.195h1.252l-1.018.745.39 1.191-1.018-.74-1.017.74.39-1.195-1.018-.74z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgUs;